/* Ares Acres — sharded asset loader.
 * Oversized theme JSON bundles are stored as `<stem>.pN.txt` shards (the Admin API caps a single
 * inline file write). This fetches every shard of a bundle in parallel, concatenates the text in
 * order and parses it — the joined string is byte-identical to the original JSON file.
 *
 *   AresAssets.loadJSON(shardMap, 'doctor-data-t50.json', fallbackUrl) -> Promise<object>
 *
 * shardMap comes from the `ares-shard-urls` snippet: { "name.json": [url1, url2, ...] }.
 * If the name is absent from the map, fallbackUrl is fetched directly, so small unsharded
 * bundles keep working unchanged.
 */
(function (root) {
  'use strict';
  function text(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('shard ' + r.status + ' ' + url);
      return r.text();
    });
  }
  var AresAssets = {
    loadJSON: function (shardMap, name, fallbackUrl) {
      var urls = shardMap && shardMap[name];
      if (!urls || !urls.length) {
        if (!fallbackUrl) return Promise.reject(new Error('no source for ' + name));
        return fetch(fallbackUrl).then(function (r) {
          if (!r.ok) throw new Error(name + ' ' + r.status);
          return r.json();
        });
      }
      return Promise.all(urls.map(text)).then(function (parts) {
        return JSON.parse(parts.join(''));
      });
    }
  };
  if (typeof module === 'object' && module.exports) module.exports = AresAssets;
  root.AresAssets = AresAssets;
})(typeof window !== 'undefined' ? window : this);
